import * as personeelsinstellingenGen from "@personeel/gen/hey-api/zod.gen";
import { z } from "zod";

export type PersoneelsinstellingenModel = z.infer<
  typeof personeelsinstellingenGen.zPersoneelsinstellingen
>;

export { zPersoneelsinstellingen as PersoneelsinstellingenSchema } from "@personeel/gen/hey-api/zod.gen";

export const PersoneelsinstellingenArraySchema = z.array(
  personeelsinstellingenGen.zPersoneelsinstellingen,
);
